


























































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import CouponCard from '@/components/CouponCard.vue';
import CouponDialog from '@/components/CouponDialog.vue';
import OnceButton from '@/components/OnceButton.vue';
import { CouponItem } from '@/models/CouponItem';
import { CouponsRepository } from '@/repositories/CouponsRepository';
import ContactPanel from '@/components/ContactPanel.vue';

@Component({
  components: {
    'once-button': OnceButton,
    'coupon-card': CouponCard,
    CouponDialog,
    ContactPanel
  }
})
export default class P0710 extends Vue {
  // チャージスポット ID=50
  readonly ALLIANCE_SERVICE_ID: number = 50;
  coupons: CouponItem[] = [];

  couponDetailDialog = false; // クーポンクリック時のv-dialogをコントロールする

  login() {
    this.$auth.loginWithRedirect();
  }

  get repository() {
    return new CouponsRepository(
      this.$store.state.isSP,
      this.$store.state.supportsWebP
    );
  }

  @Watch('$auth.loading', { immediate: true })
  async loadCoupon() {
    const coupon = this.$auth.isAuthenticated
      ? await this.repository.select(this.ALLIANCE_SERVICE_ID)
      : await this.repository.selectWithoutCode(this.ALLIANCE_SERVICE_ID);

    if (coupon) {
      this.coupons = [coupon];
    }
  }

  /**
   * ダイアログを表示する
   */
  showDialog() {
    if (!this.coupons.length) {
      // 運用ミスをしない限りlength=0にはならないが、チェックをしておく
      return;
    }
    this.couponDetailDialog = true;
    this.$dataLayer.push({
      coupon_title: this.coupons[0],
      event: 'coupon-click'
    });
  }
  //新規登録
  private signup() {
    this.$auth.loginWithRedirect({
      initialDisplay: 'signup'
    });
  }

  readonly SERVICE_SLUG = 'chargespot';
  //タブ定数
  readonly TAB_SCENE = 'Scene';
  readonly TAB_FEATURE = 'Feature';

  //現在のタブの値
  tabStatus = this.TAB_SCENE;

  //サービスのURL
  readonly USE_SERVICE_URL = 'https://www.chargespot.jp/';

  //QA表示・非表示トグル動作（DOMを直接操作している）
  toggleAnswer(e: Event) {
    let target = e.target as HTMLElement;
    let targetParent = target.parentNode as HTMLElement;
    let targetBox = targetParent.nextSibling as HTMLElement;
    if (target.getAttribute('aria-expanded') === 'true') {
      target.setAttribute('aria-expanded', 'false');
      targetBox.setAttribute('aria-hidden', 'true');
    } else {
      target.setAttribute('aria-expanded', 'true');
      targetBox.setAttribute('aria-hidden', 'false');
    }
  }

  //ご利用シーン・サービスの特徴 上部へ
  toTabNav() {
    let elem = document.getElementById('serTabNavTop') as HTMLElement;
    let top =
      elem instanceof HTMLElement === true
        ? window.pageYOffset + elem.getBoundingClientRect().top
        : 0;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }
}
